export type AppLanguage = 'ru' | 'en';

export const DEFAULT_LANGUAGE: AppLanguage = 'ru';
export const SUPPORTED_LANGUAGES: AppLanguage[] = ['ru', 'en'];
export const APP_LANGUAGE_KEY = 'app_language';
export const LANGUAGE_CHANGED_EVENT = 'app-language-changed';

export const normalizeLanguage = (value?: string | null): AppLanguage => {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace('_', '-');

  if (normalized.startsWith('en')) return 'en';
  if (normalized.startsWith('ru')) return 'ru';
  return DEFAULT_LANGUAGE;
};

export const isSupportedLanguage = (value?: string | null): value is AppLanguage => {
  const normalized = String(value ?? '').trim().toLowerCase().replace('_', '-');
  return normalized === 'ru' || normalized === 'en' || normalized.startsWith('ru-') || normalized.startsWith('en-');
};

export const getStoredLanguage = (): AppLanguage => {
  try {
    return normalizeLanguage(localStorage.getItem(APP_LANGUAGE_KEY));
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

export const persistLanguage = (language: AppLanguage) => {
  try {
    localStorage.setItem(APP_LANGUAGE_KEY, language);
  } catch {}

  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(LANGUAGE_CHANGED_EVENT, { detail: { language } }));
  }
};

export const languageToLocale = (language: AppLanguage) => (language === 'en' ? 'en-US' : 'ru-RU');
